export const NAV = [
  {
    key: "getting-started",
    label: "Getting Started",
    intro: "Work out what you're actually looking at.",
    items: [
      { slug: "getting-started", label: "Overview" },
      { slug: "agency-legitimacy", label: "Is this agency legitimate?" },
      { slug: "understanding-contracts", label: "Understanding contracts & commission" },
      { slug: "for-parents", label: "For parents: what to ask before signing" },
    ],
  },
  {
    key: "money",
    label: "Money & Contracts",
    intro: "How the money flows, and how to plan around it.",
    items: [
      { slug: "money-contracts", label: "Overview" },
      { slug: "commission", label: "How agency commission works" },
      { slug: "self-employment-tax", label: "Self-employment & tax (UK)" },
      { slug: "payment-timelines", label: "Payment timelines" },
      { slug: "budgeting", label: "Budgeting between bookings" },
    ],
  },
  {
    key: "castings",
    label: "Castings & Sets",
    intro: "What actually happens when you walk in the door.",
    items: [
      { slug: "castings-sets", label: "Overview" },
      { slug: "casting-attire", label: "What to wear to a casting" },
      { slug: "casting-etiquette", label: "Casting day etiquette & timing" },
      { slug: "on-set", label: "On-set professionalism" },
    ],
  },
  {
    key: "legal",
    label: "Legal & Visas",
    intro: "US O-1 visas and tear sheets, in plain English.",
    items: [
      { slug: "us-visas-tearsheets", label: "US visas & tear sheets" },
    ],
  },
  {
    key: "safety",
    label: "Safety",
    intro: "Your rights, in the room and out.",
    items: [
      { slug: "safety", label: "Overview" },
      { slug: "right-to-say-no", label: "Your right to say no on set" },
      { slug: "digital-safety", label: "Digital & location safety" },
      { slug: "safeguarding-contacts", label: "If something feels wrong" },
    ],
  },
  {
    key: "tools",
    label: "Tools & Resources",
    intro: "Apps, tools, and further reading.",
    items: [
      { slug: "tools-resources", label: "Overview" },
    ],
  },
];

export const findPageMeta = (slug) => {
  for (const cluster of NAV) {
    const found = cluster.items.find((i) => i.slug === slug);
    if (found) return { ...found, cluster };
  }
  return null;
};
